export const ACTIVITY_MODE_WALK = "walk";
export const ACTIVITY_MODE_BIKE = "bike";
export const ACTIVITY_MODE_BOTH = "both";

export const ACTIVITY_MODE_STORAGE_KEY = "trekkin.activityMode";

export const ACTIVITY_MODE_COLORS = Object.freeze({
  [ACTIVITY_MODE_WALK]: "#0d6efd",
  [ACTIVITY_MODE_BIKE]: "#f4c20d",
  [ACTIVITY_MODE_BOTH]: "#28a745",
});

export function normalizeActivityMode(value, fallback = ACTIVITY_MODE_WALK) {
  const raw = String(value || "").trim().toLowerCase();
  if (raw === ACTIVITY_MODE_BIKE || raw === "bicycle" || raw === "cycling") {
    return ACTIVITY_MODE_BIKE;
  }
  if (raw === ACTIVITY_MODE_BOTH || raw === "all" || raw === "ambos") {
    return ACTIVITY_MODE_BOTH;
  }
  if (raw === ACTIVITY_MODE_WALK || raw === "hike" || raw === "walking") {
    return ACTIVITY_MODE_WALK;
  }
  return fallback;
}

export function resolveActivityMode(value) {
  return normalizeActivityMode(value, ACTIVITY_MODE_WALK);
}

export function isActivityModeCompatible(itemMode, activeMode) {
  const item = normalizeActivityMode(itemMode, ACTIVITY_MODE_WALK);
  const active = normalizeActivityMode(activeMode, ACTIVITY_MODE_WALK);
  return item === ACTIVITY_MODE_BOTH || item === active;
}

export function getActivityModeLabel(mode) {
  const normalized = normalizeActivityMode(mode, ACTIVITY_MODE_WALK);
  if (normalized === ACTIVITY_MODE_BIKE) return "Bicicleta";
  if (normalized === ACTIVITY_MODE_BOTH) return "Ambos";
  return "Caminhada";
}

export function getActivityModeColor(mode) {
  const normalized = normalizeActivityMode(mode, ACTIVITY_MODE_WALK);
  return ACTIVITY_MODE_COLORS[normalized];
}
